module.exports = __webpack_public_path__ + "assets/img/marketingStrategy.99c12251.png";